import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

import { Column } from '@simplywallst/ui-core';

export const SnowflakeWrapper = styled(Column)`
  ${media.lgUp`
    position: absolute;
    z-index: 1;
    top: 0;
    right: 0;
  `};
`;

export const ColumnLeft = styled(Column)`
  ${media.lgUp`
		padding-right: ${({ theme }) => theme.x4spacePx}px;
	`};
`;

export const ActionsWrapper = styled(ColumnLeft)`
  margin-top: ${({ theme }) => theme.x3spacePx}px;
  ${media.lgUp`
    margin-top: 0;
		min-height: 270px;
	`};
`;

export const SummaryWrapper = styled('div')`
  position: relative;
  color: white;
`;

export const SummarySubHead = styled('h4')`
  ${({ theme }) => theme.typography.xSmall}
  text-transform: uppercase;
  margin-top: 0;
  margin-bottom: ${({ theme }) => theme.x1space}rem;
  opacity: 0.7;
`;

export const HideLgDown = styled('span')`
  ${media.lgDown`
		display: none;
	`};
`;
